import {dayName, dayNumeric, dayOfMonth, monthName, weekdayName} from "@/event/calendar/Formating.ts";
import {drawTextLine, measure, TextRun} from "@/bpm/canvas/CanvasUtils.ts";
import {Component} from "@/event/calendar/dom/Component.ts";
import {DrawingContext} from "@/event/calendar/dom/DrawingContext.ts";
import {type Rect} from "@/event/calendar/Shapes.ts";
import {CalendarViewName} from "@/event/calendar/CalendarModel.ts";
import {BUTTON_HEIGHT} from "@/event/calendar/Constants.ts";
import {DateRange} from "@/store/CalendarStore.ts";

/**
 * Renders view label at top left corner. Usually displays what is in focus
 */
export class ViewLabelComponent extends Component {
	public range:DateRange;
	public viewType:CalendarViewName;

	constructor() {
		super();
	}

	layoutSelf(dc: DrawingContext, contentBox: Rect) {
	}

	protected drawContent(dc: DrawingContext, area: Rect) {
		if (!this.range) return;

		const sameYear = this.range.start.getFullYear() === this.range.end.getFullYear();
		const sameMonth = sameYear && this.range.start.getMonth() === this.range.end.getMonth();
		const sameDay = sameMonth && this.range.start.getDate() === this.range.end.getDate();

		let x = 0;
		let yOffset = BUTTON_HEIGHT - 4;
		const fontSize = dc.style.getPropertyValue("--form-header-font-size");
		const fontFamily = dc.style.getPropertyValue("--font");
		const fg = dc.style.getPropertyValue("--fg");
		const runs:TextRun[] = [];
		const rs = this.range.start;
		const re = this.range.end;
		const bold = "bold "+fontSize + " " + fontFamily;
		const light = "300 "+fontSize + " " + fontFamily;

		let lightPrefix, boldMiddle, lightSuffix;
		switch (this.viewType) {
			case "days":
				if (sameDay) {
					runs.push({ text: weekdayName(rs)+" ", font:light, color: fg })
					runs.push({ text: dayName(rs), font:bold, color: fg })
					runs.push({ text: " "+rs.getFullYear().toString(), font:light, color: fg })
				} else if (sameMonth) {
					runs.push({ text: dayOfMonth(rs), font:bold, color: fg })
					runs.push({ text: " - ", font:light, color: fg })
					runs.push({ text: dayName(re), font:bold, color: fg })
					runs.push({ text: " "+rs.getFullYear().toString(), font:light, color: fg })
				} else if (sameYear) {
					runs.push({ text: dayNumeric(rs), font:bold, color: fg })
					runs.push({ text: " - ", font:light, color: fg })
					runs.push({ text: dayNumeric(re), font:bold, color: fg })
					runs.push({ text: " "+re.getFullYear().toString(), font:light, color: fg })
				} else {
					runs.push({ text: dayNumeric(rs), font:bold, color: fg })
					runs.push({ text: " "+rs.getFullYear().toString(), font:light, color: fg })
					runs.push({ text: " - ", font:light, color: fg })
					runs.push({ text: dayNumeric(re), font:bold, color: fg })
					runs.push({ text: " "+re.getFullYear().toString(), font:light, color: fg })
				}
				break;
			case "weeks":
				if (sameMonth) {
					runs.push({ text: monthName(rs)+" ", font:bold, color: fg })
					runs.push({ text: rs.getFullYear().toString(), font:light, color: fg })
				} else if (sameYear) {
					runs.push({ text: monthName(rs), font:bold, color: fg })
					runs.push({ text: " - ", font:light, color: fg })
					runs.push({ text: monthName(re)+" ", font:bold, color: fg })
					runs.push({ text: rs.getFullYear().toString(), font:light, color: fg })
				} else {
					runs.push({ text: monthName(rs)+" ", font:bold, color: fg })
					runs.push({ text: rs.getFullYear().toString(), font:light, color: fg })
					runs.push({ text: " - ", font:light, color: fg })
					runs.push({ text: monthName(re)+" ", font:bold, color: fg })
					runs.push({ text: re.getFullYear().toString(), font:light, color: fg })
				}
				break;
			default:
			case "months":
				if (sameYear) {
					runs.push({ text: rs.getFullYear().toString(), font:bold, color: fg })
				} else {
					runs.push({ text: rs.getFullYear().toString(), font:bold, color: fg })
					runs.push({ text: " - ", font:light, color: fg })
					runs.push({ text: re.getFullYear().toString(), font:bold, color: fg })
				}
				break;
		}
		drawTextLine(dc.ctx, runs, x, yOffset, this.width);
	}
}

